import React from 'react';

const PATHS = {
  clock: (
    <>
      <circle cx="12" cy="12" r="9.5" />
      <path d="M12 7v5l3.2 2" />
    </>
  ),
  package: (
    <>
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      <path d="M3.3 7 12 12.1 20.7 7" />
      <path d="M12 22V12" />
    </>
  ),
  shoppingBag: (
    <>
      <path d="M6.5 2 3.5 6.5v14a1.5 1.5 0 0 0 1.5 1.5h14a1.5 1.5 0 0 0 1.5-1.5v-14L17.5 2z" />
      <path d="M3.5 6.5h17" />
      <path d="M16 10.5a4 4 0 0 1-8 0" />
    </>
  ),
  compass: (
    <>
      <circle cx="12" cy="12" r="9.5" />
      <path d="M15.8 8.2 13.7 13.7 8.2 15.8 10.3 10.3z" />
    </>
  ),
  layers: (
    <>
      <path d="M12 2 2.5 7 12 12 21.5 7z" />
      <path d="M2.5 12 12 17 21.5 12" />
      <path d="M2.5 17 12 22 21.5 17" />
    </>
  ),
  zap: (
    <path d="M13 2 3.5 14h7.5l-1 8L19.5 10H12z" />
  ),
  mapPin: (
    <>
      <path d="M20.5 10.5c0 6.5-8.5 11.5-8.5 11.5s-8.5-5-8.5-11.5a8.5 8.5 0 0 1 17 0z" />
      <circle cx="12" cy="10.5" r="2.8" />
    </>
  ),
  bookOpen: (
    <>
      <path d="M2.5 4.5h5.2a3.5 3.5 0 0 1 3.5 3.5v13a2.7 2.7 0 0 0-2.7-2.7H2.5z" />
      <path d="M21.5 4.5h-5.2a3.5 3.5 0 0 0-3.5 3.5v13a2.7 2.7 0 0 1 2.7-2.7h6z" />
    </>
  ),
  fileText: (
    <>
      <path d="M14.5 2.5h-8a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-12z" />
      <path d="M14.5 2.5v5h5" />
      <path d="M8.5 13.5h7" />
      <path d="M8.5 17.5h7" />
    </>
  ),
  target: (
    <>
      <circle cx="12" cy="12" r="9.5" />
      <circle cx="12" cy="12" r="5.5" />
      <circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none" />
    </>
  ),
  rocket: (
    <>
      <line x1="21.5" y1="2.5" x2="10.5" y2="13.5" />
      <path d="M21.5 2.5 14.5 21.5 10.5 13.5 2.5 9.5z" />
    </>
  ),
  users: (
    <>
      <path d="M16.5 20.5v-1.8a3.7 3.7 0 0 0-3.7-3.7H6.7A3.7 3.7 0 0 0 3 18.7v1.8" />
      <circle cx="9.8" cy="7.8" r="3.8" />
      <path d="M21.5 20.5v-1.8a3.7 3.7 0 0 0-2.8-3.6" />
      <path d="M15.2 4.2a3.8 3.8 0 0 1 0 7.2" />
    </>
  ),
  trendingUp: (
    <>
      <polyline points="2.5 18.5 10 11 14.5 15.5 21.5 7.5" />
      <polyline points="16 7.5 21.5 7.5 21.5 13" />
    </>
  ),
  creditCard: (
    <>
      <rect x="2" y="5" width="20" height="14" rx="2.2" />
      <line x1="2" y1="10.2" x2="22" y2="10.2" />
    </>
  ),
  phone: (
    <path d="M21 16.4v3a2 2 0 0 1-2.2 2 18.5 18.5 0 0 1-8-2.9 18.2 18.2 0 0 1-5.6-5.6 18.5 18.5 0 0 1-2.9-8A2 2 0 0 1 4.3 3h3a2 2 0 0 1 2 1.7c.13.9.35 1.8.66 2.6a2 2 0 0 1-.45 2.1l-1.27 1.27a14.7 14.7 0 0 0 5.6 5.6l1.27-1.27a2 2 0 0 1 2.1-.45c.83.31 1.7.53 2.6.66a2 2 0 0 1 1.79 2.03z" />
  ),
  mail: (
    <>
      <rect x="2.5" y="4.5" width="19" height="15" rx="2" />
      <path d="M3 6l9 6.5L21 6" />
    </>
  ),
  shield: (
    <path d="M12 2.5 20 6v6c0 6-3.7 9-8 11.5C7.7 21 4 18 4 12V6z" />
  ),
  briefcase: (
    <>
      <rect x="2.5" y="7.5" width="19" height="13" rx="2" />
      <path d="M16 20V5.5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2V20" />
    </>
  ),
  check: (
    <path d="M4 12.5 9.5 18 20 6" />
  ),
  truck: (
    <>
      <rect x="1" y="4" width="15" height="12.5" rx="1.2" />
      <path d="M16 8.5h4l3 3.5v4.5h-7z" />
      <circle cx="6" cy="19" r="2.1" />
      <circle cx="18" cy="19" r="2.1" />
    </>
  ),
  cart: (
    <>
      <circle cx="9.5" cy="20.5" r="1.4" fill="currentColor" stroke="none" />
      <circle cx="18.5" cy="20.5" r="1.4" fill="currentColor" stroke="none" />
      <path d="M1.5 2h3l2.6 12.6a2 2 0 0 0 2 1.6h9a2 2 0 0 0 2-1.55L22 6.5H6" />
    </>
  ),
  chevronDown: (
    <path d="M5 8.5 12 15.5 19 8.5" />
  ),
  search: (
    <>
      <circle cx="10.5" cy="10.5" r="7.5" />
      <path d="M21 21 16 16" />
    </>
  ),
  helpCircle: (
    <>
      <circle cx="12" cy="12" r="9.5" />
      <path d="M9.2 9.3a2.9 2.9 0 0 1 5.6 1c0 1.9-2.7 2.2-2.8 4" />
      <circle cx="12" cy="16.7" r="0.15" fill="currentColor" stroke="currentColor" strokeWidth="1.8" />
    </>
  ),
  arrowLeft: (
    <>
      <line x1="20" y1="12" x2="4" y2="12" />
      <polyline points="10 6 4 12 10 18" />
    </>
  ),
  trash: (
    <>
      <path d="M4 6h16" />
      <path d="M9 6V4.5A1.5 1.5 0 0 1 10.5 3h3A1.5 1.5 0 0 1 15 4.5V6" />
      <path d="M6 6l1 14.5A1.5 1.5 0 0 0 8.5 22h7a1.5 1.5 0 0 0 1.5-1.5L18 6" />
    </>
  ),
  refresh: (
    <>
      <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
      <path d="M21 3v5h-5" />
      <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
      <path d="M3 21v-5h5" />
    </>
  ),
  share: (
    <>
      <circle cx="18" cy="5" r="2.5" />
      <circle cx="6" cy="12" r="2.5" />
      <circle cx="18" cy="19" r="2.5" />
      <path d="M8.2 10.7 15.8 6.3" />
      <path d="M8.2 13.3 15.8 17.7" />
    </>
  ),
  download: (
    <>
      <path d="M12 3v12" />
      <path d="M7.5 10.5 12 15l4.5-4.5" />
      <path d="M4 18.5V20a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.5" />
    </>
  ),
};

export default function Icon({ name, size = 20, strokeWidth = 1.8, className = '' }) {
  const content = PATHS[name];
  if (!content) return null;
  return (
    <svg
      className={`icon ${className}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {content}
    </svg>
  );
}
